import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, PRESCRIPTION_DETAILS_PATH, PRESCRIPTION_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const PrescriptionPage = lazy(
  () => import('@features/Medication/Prescription/pages/PrescriptionPage/PrescriptionPage')
);
const PrescriptionDetailPage = lazy(
  () => import('@features/Medication/Prescription/pages/PrescriptionDetailPage/PrescriptionDetailPage')
);

export const PRESCRIPTION_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <PrescriptionPage />,
    displayTitle: () => 'Prescription Records',
    pageType: PageType.PRIVATE,
    path: PRESCRIPTION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.prescriptionRecords,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <PrescriptionDetailPage />,
    displayTitle: () => 'Prescription Details',
    pageType: PageType.PRIVATE,
    path: PRESCRIPTION_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.prescriptionRecords,
  },
];
